import useStore from "../../../store"
import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import NAPWorkflow from "./NAPWorkflow"
import { useTranslation } from "react-i18next"
import { Wizard, WizardHeader } from "../../ui/wizard"
import rollbarLogger from "../../../utilities/rollbarLogger"
import { createFileFromBase64 } from "../../../utilities/createFileFromBase64"

export default function NAP({ issues = false }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const NAPBlackbook = useStore((state) => state.NAPBlackbook)
  const currentStep = useStore((state) => state.currentStep)
  const setCurrentStep = useStore((state) => state.setCurrentStep)
  const NAPIssues = useStore((state) => state.NAPIssues)
  const NAPRequiresBankPayoff = useStore((state) => state.NAPRequiresBankPayoff)
  const setTopNavHidden = useStore((state) => state.setTopNavHidden)
  const setNavBarHidden = useStore((state) => state.setNavBarHidden)
  const [workflow, setWorkflow] = useState([])
  const setNAPWorkflowLength = useStore((state) => state.setNAPWorkflowLength)
  const images = useStore((state) => state.NAPImages)
  const setNAPImages = useStore((state) => state.setNAPImages)
  const user = useStore((state) => state.user)
  const rollbar = rollbarLogger(user)

  useEffect(() => {
    setWorkflow(NAPWorkflow(NAPIssues, issues, NAPRequiresBankPayoff))
  }, [NAPRequiresBankPayoff])

  useEffect(() => {
    if (!NAPBlackbook) { navigate('/blackbook') }
  }, [])

  useEffect(() => {
    setTopNavHidden(true)
    if (currentStep === workflow.length - 1) {
      setNavBarHidden(true)
    }

    return () => {
      setTopNavHidden(false)
      setNavBarHidden(false)
    }
  }, [currentStep])

  useEffect(() => {
    setNAPWorkflowLength(workflow.length)
  }, [workflow])

  const handleBack = () => {
    if (currentStep <= 0) {
      window.history.back()
    } else {
      setCurrentStep(currentStep - 1)
    }
  }

  return(
    <Wizard>
      <WizardHeader
        title={issues ? t('Edit Floor Request') : t('Request Floor')}
        progress={workflow.length > 0 ? ((currentStep + 1) / workflow.length * 100) : 0}
        showBackButton={currentStep !== workflow.length - 1}
        handleBack={handleBack}
      />
      {workflow[currentStep]}
    </Wizard>
  )
}